/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1TenantState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_TENANT_STATE_ENTITY_NAME = 'ixm.userauth.v1.Tenant';
export const ixmUserauthV1TenantStateEntity = new schema.Entity<IxmUserauthV1TenantState>(IXM_USERAUTH_V1_TENANT_STATE_ENTITY_NAME, {}, { idAttribute: 'tenantId' });

